import { useQuery } from '@tanstack/react-query';
import { TANSTACK_CARD_TRACKER_OBJECTS_KEY } from '../utils/constants';
import { useSuiClient } from '@mysten/dapp-kit';
import { parseObjectFields } from '../utils/utils';
import { IConsts } from 'sudo-ts-sdk';
import { MoveStruct } from '@mysten/sui.js/src/client';

export type CardTrackerType = Record<number, MoveStruct>;

export function useCardTrackers({ consts }: { consts: IConsts }) {
  const provider = useSuiClient();

  return useQuery({
    queryKey: [TANSTACK_CARD_TRACKER_OBJECTS_KEY],
    queryFn: async (): Promise<{
      cardTrackers: CardTrackerType;
    }> => {
      // get the items from rpc.
      const silverCardTracker = await provider.getObject({
        id: `${consts.sudoNft.silverCardTracker}`,
        options: { showType: true, showContent: true },
      });

      const silverCardTrackerFields = parseObjectFields([silverCardTracker]);

      const emeraldCardTracker = await provider.getObject({
        id: `${consts.sudoNft.emeraldCardTracker}`,
        options: { showType: true, showContent: true },
      });

      const emeraldCardTrackerFields = parseObjectFields([emeraldCardTracker]);

      const blackCardTracker = await provider.getObject({
        id: `${consts.sudoNft.blackCardTracker}`,
        options: { showType: true, showContent: true },
      });

      const blackCardTrackerFields = parseObjectFields([blackCardTracker]);

      const cardTrackers = {
        0: blackCardTrackerFields[blackCardTracker.data?.objectId!] || {},
        1: emeraldCardTrackerFields[emeraldCardTracker.data?.objectId!] || {},
        2: silverCardTrackerFields[silverCardTracker.data?.objectId!] || {},
      };

      return {
        cardTrackers,
      };
    },
  });
}
